module.exports = __webpack_public_path__ + "static/img/Craig-McRae.ef3cb6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Craig-McRae.jpg
// module id = CZKT
// module chunks = 1